import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05e838d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "dialog-footer" }

import { computed, onMounted, ref } from "vue";
import { Search } from "@element-plus/icons-vue";
import UserApi from "@/api/UserApi";
import ChatItem from "@/components/ChatItem.vue";
import User from "@/mode/User";
import FriendApi from "@/api/FriendApi";
import { ElMessage } from "element-plus/es";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddFriend',
  props: {
  dialogVisible: {
    type: Boolean,
    required: true,
    default: false
  }
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;





const handleClose = () => {
  emit("close");
};

const show = computed(() => {
  return props.dialogVisible;
});

const checkUser = ref({});
const mobile = ref("");
const users = ref<Array<User>>([]);

const check = (user: User) => {
  checkUser.value = user;
};
const close = () => {
  emit("close");
};
const search = () => {
  if(mobile.value.trim().length!=4) return;
  UserApi.search(mobile.value.trim()).then((res) => {
    users.value = res.data;
  });
};

const add = () => {
  if (checkUser.value && users.value.length > 0) {
    let user = checkUser.value;
    FriendApi.add(user.id)
      .then(() => {
        ElMessage.info("添加成功");
        emit("close");
      })
      .catch((res) => {
        console.error(res);
      });
  } else {
    ElMessage.error("请选择一个用户");
  }
};

onMounted(() => {
  console.log(show.value);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
    title: "添加好友",
    width: "400px",
    "before-close": handleClose
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, { onClick: close }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: add
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_form_item, { label: "手机号" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: mobile.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mobile).value = $event)),
              class: "w-50 m-1",
              placeholder: "请输入手机尾号后四位，按enter键",
              "suffix-icon": _unref(Search),
              onBlur: search,
              onKeyup: _withKeys(search, ["enter","down"])
            }, null, 8, ["modelValue", "suffix-icon", "onKeyup"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["solid", checkUser.value.id === user.id ? 'active' : '']),
            onClick: ($event: any) => (check(user))
          }, [
            _createVNode(ChatItem, {
              id: user.id,
              img: user.avatar,
              username: user.name,
              showDel: false
            }, null, 8, ["id", "img", "username"])
          ], 10, _hoisted_1))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})